import React from 'react';
import { EstimateLineItem, Vehicle } from '../../types';
import ServiceItemsTable from '../ServiceItemsTable';
import MobileServiceItemsTable from '../MobileServiceItemsTable';

export interface EstimateLineItemsProps {
  /** Kept for call-site compatibility; the editors operate on the in-memory items array. */
  estimateId?: number;
  items: EstimateLineItem[];
  isMobile: boolean;
  isLocked: boolean;
  onItemsChange: (items: EstimateLineItem[]) => void;
  taxRate?: number;
  vehicle?: Vehicle;
}

/**
 * Estimate line-item editor.
 *
 * Uses the full-featured ServiceItemsTable (desktop) / MobileServiceItemsTable
 * (mobile), which support labor + per-part discounts, parts add/edit/delete,
 * templates, and accurate pricing. These operate directly on EstimateLineItem[]
 * and report changes via onChange — the estimate persists the whole array when
 * saved, so no per-item API calls are made here.
 */
export const EstimateLineItems: React.FC<EstimateLineItemsProps> = ({
  items,
  isMobile,
  isLocked,
  onItemsChange,
  taxRate,
  vehicle,
}) => {
  const Editor = isMobile ? MobileServiceItemsTable : ServiceItemsTable;
  return (
    <Editor
      items={items}
      onChange={onItemsChange}
      disabled={isLocked}
      taxRate={taxRate}
      vehicle={vehicle}
    />
  );
};
